import { render, staticRenderFns } from "./CrudDataCreate.vue?vue&type=template&id=797b755e&scoped=true"
import script from "./CrudDataCreate.vue?vue&type=script&lang=js"
export * from "./CrudDataCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b755e",
  null
  
)

export default component.exports